// @ts-nocheck
/* eslint-disable */
export const minusIcon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8333 10.8333H4.16663V9.16663H15.8333V10.8333Z" fill="currentColor"/></svg>`,
    name: 'minus' as const
};